import React from 'react';

export const Star: React.FC<{
  size: number;
  innerColor?: string;
  strokeColor?: string;
}> = ({ size, innerColor, strokeColor }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.086 22.08c-.49 0-.977-.144-1.405-.411L12 19.358l-3.68 2.31c-.429.268-.915.411-1.406.411a2.688 2.688 0 01-2.097-1.03 2.625 2.625 0 01-.473-2.267l1.062-4.216-3.337-2.788a2.639 2.639 0 01-.82-2.85 2.636 2.636 0 012.337-1.825l4.336-.295 1.62-4.033A2.637 2.637 0 0112 1.115c1.088 0 2.052.652 2.458 1.66l1.62 4.033 4.336.295a2.63 2.63 0 012.338 1.824 2.639 2.639 0 01-.821 2.851l-3.337 2.788 1.061 4.216a2.61 2.61 0 01-.472 2.267 2.681 2.681 0 01-2.097 1.03z"
        fill={innerColor ?? '#ffc700'}
      />
      <path
        d="M12 2.23c.584 0 1.164.322 1.423.96l1.883 4.684 5.036.344c1.379.093 1.941 1.82.88 2.703l-3.873 3.235 1.231 4.894c.263 1.04-.562 1.91-1.49 1.91-.272 0-.549-.077-.812-.242l-4.274-2.68-4.274 2.68c-.263.165-.544.241-.812.241-.928 0-1.749-.874-1.49-1.91l1.231-4.893-3.872-3.235c-1.062-.887-.5-2.61.879-2.703l5.037-.344 1.882-4.684c.25-.638.83-.96 1.415-.96zM12 0a3.751 3.751 0 00-3.494 2.36l-1.36 3.382-3.636.245A3.737 3.737 0 00.186 8.58a3.75 3.75 0 001.165 4.051l2.797 2.338-.888 3.538a3.73 3.73 0 00.674 3.225 3.815 3.815 0 002.98 1.463c.7 0 1.392-.2 1.998-.58L12 20.674l3.087 1.94c.607.38 1.298.58 1.998.58a3.815 3.815 0 002.98-1.463c.714-.915.96-2.088.674-3.226l-.887-3.537 2.797-2.338a3.743 3.743 0 001.164-4.05 3.748 3.748 0 00-3.323-2.593l-3.636-.245-1.361-3.378A3.749 3.749 0 0012 0z"
        fill={strokeColor ?? '#ad8700'}
      />
    </svg>
  );
};
